import React from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  Button
} from '@mui/material'
import { LockTwoTone } from '@mui/icons-material'
import { useStyles } from './style'

const SSOSessionExpiredModal = ({
  open,
  onSignIn,
  isSigningIn = false
}) => {
  const classes = useStyles()

  const handleSignIn = () => {
    onSignIn()
  }

  return (
    <Dialog
      open={open}
      aria-label='SSO session expired dialog'
      data-test='sso-session-expired-dialog'
      PaperProps={{ className: classes.root }}
      disableEscapeKeyDown
      onClose={() => {}} // Disable closing
    >
      <DialogContent>
        <Grid container alignItems='flex-start' spacing={2}>
          <Grid item>
            <Grid
              container
              justifyContent='center'
              alignItems='center'
              className={classes.iconContainer}
            >
              <LockTwoTone fontSize='medium' className={classes.icon} />
            </Grid>
          </Grid>
          <Grid item xs>
            <Typography variant='h6' className={classes.title}>
              Session Ended
            </Typography>
            <Typography variant='body2' className={classes.description}>
              You’ve been logged out. Sign in again to resume..
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={handleSignIn}
          variant='contained'
          color='primary'
          disabled={isSigningIn}
          className={classes.signInButton}
        >
          {isSigningIn ? 'Signing In...' : 'Sign In'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

SSOSessionExpiredModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onSignIn: PropTypes.func.isRequired,
  isSigningIn: PropTypes.bool,
  tenantName: PropTypes.string
}

export default SSOSessionExpiredModal
